import { mentionReplacedDescription } from '../../../../../javascript/components/HighlightedMentions/utils';
import { stripMarkdownFormattingForMentions } from '../../../../../javascript/components/HighlightedMentions/stripMarkdownForPreview';

type TaskLike = { display: string; title?: string | null };

/**
 * Single-line label for slash "Link task" rows: prefer title, else description;
 * mentions normalized, markdown stripped.
 */
export function plainTaskMenuLabel(task: TaskLike): string {
  const source = (task.title && String(task.title).trim()) || task.display || '';
  const withMentions = mentionReplacedDescription(source);
  const stripped = stripMarkdownFormattingForMentions(withMentions);
  return mentionReplacedDescription(stripped).replace(/\s+/g, ' ').trim();
}
